export class StepIndicator {
    private configuratorWrapper: HTMLDivElement;
    readonly totalSteps: number;

    constructor(configuratorWrapper: HTMLDivElement, totalSteps: number) {
        this.configuratorWrapper = configuratorWrapper;
        this.totalSteps = totalSteps;
    }

    setStep(step: number): void {
        // Normalize
        if (step < 1) {
            step = 1;
        } else if (step > this.totalSteps) {
            step = this.totalSteps;
        }
        this.configuratorWrapper.dataset.step = step.toString();
        this.configuratorWrapper.setAttribute('data-step', step.toString());
		setTimeout(() => {
			this.configuratorWrapper.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			})
		}, 500);
    }

	initStepClick(wrapper : HTMLElement) {
		for (const step of wrapper.querySelectorAll<HTMLDivElement>('.configurator-steps-indicator .step.prev[data-step]:not(.initialized)')) {
			const stepNum = parseInt(step.dataset.step);
			step.addEventListener('click', () => {
				this.setStep(stepNum);
				this.configuratorWrapper.dispatchEvent(new CustomEvent('step-change', {detail: stepNum}))
			})
			step.classList.add('initialized');
		}
	}
}
